<template>
  <div class="createGroup">
    <div class="createGroup_cont">
      <el-steps :active="stepActive">
        <el-step title="步骤 1" icon="el-icon-edit"></el-step>
        <el-step title="步骤 2" icon="el-icon-upload"></el-step>
        <el-step title="步骤 3" icon="el-icon-picture"></el-step>
        <el-step title="步骤 4" icon="el-icon-picture"></el-step>
      </el-steps>

      <template>
        <onePage
          :oneState="oneState"
          :itemClass.sync="itemClass"
          @upOneData="upOneData"
          @addType="addType"
          v-show="stepActive == 1 ? true : false"
        ></onePage>
      </template>

      <template>
        <towPage :itemClass="itemClass" v-show="stepActive == 2 ? true : false"></towPage>
      </template>

      <template v-if="type == 1">
        <threePage
          :itemClass="itemClass"
          :threeState="threeState"
          v-show="stepActive == 3 ? true : false"
        ></threePage>
      </template>
      <template v-else>
        <voucherPage  v-show="stepActive == 3 ? true : false"></voucherPage>
      </template>

      <template>
        <fourPage :type="type" v-show="stepActive == 4 ? true : false"></fourPage>
      </template>
    </div>
    <div class="bottom_operate">
      <el-button type="primary" size="small" v-if="stepActive == 1" @click="onePageConfirm">确认</el-button>
      <template v-if="stepActive >= 2">
        <el-button size="small" @click="stepActive--">上一步</el-button>
        <el-button type="primary" size="small" @click="nextPage" v-if="stepActive > 1&& stepActive<4">下一步</el-button>
        <el-button type="primary" size="small" v-else @click="finishGoBack">完成</el-button>
      </template>
    </div>
  </div>
</template>

<script>
import onePage from "@/components/goodsGroup/onePage";
import towPage from "@/components/goodsGroup/towPage";
import threePage from "@/components/goodsGroup/threePage";
import fourPage from "@/components/goodsGroup/fourPage";
import voucherPage from "@/components/goodsGroup/voucherPage";
export default {
  components: {
    onePage,
    towPage,
    threePage,
    fourPage,
    voucherPage
  },
  data() {
    return {
      type: "",
      itemClass: "",
      stepActive: 1,
      oneState: false,
      threeState: false,
      oneData: {}
    };
  },
  mounted() {},
  methods: {
    addType(val) {
      // 判断添加类型
      this.type = val;
    },
    nextPage() {
      // 下一页
      this.stepActive++;
      if ( this.stepActive == 2) {
        this.threeState = true;
      }
    },
    upOneData(val) {
      // 获取第一页数据
      this.oneData = val;
    },
    finishGoBack() {
      this.$router.push("groupProduct");
    },
    // 获取第一页数据
    onePageConfirm() {
      this.stepActive++;
      this.oneState = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.createGroup {
  width: 100%;
  padding: 15px 25px 100px;
  height: 100%;
  overflow: auto;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
  // position: relative;
  .bottom_operate {
    background: #fff;
    width: 100%;
    height: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 0;
    left: 0;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.16);
    border-radius: 10px 10px 0px 0px;
  }
}
</style>

<style lang="scss">
.createGroup {
}
</style>
